import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const helpDeskComplaint = createAsyncThunk(
  "helpDeskComplaint",
  async ({ current_status, startDate, endDate }) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/help-desk/get-all`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          params: {
            ...(current_status && { current_status }),
            ...(startDate && endDate && { startDate, endDate }),
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  helpDeskComplaintData: null,
  isError: false,
  errorMessage: "",
};
const helpDeskComplaintSlice = createSlice({
  name: "helpDeskComplaint",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(helpDeskComplaint.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(helpDeskComplaint.fulfilled, (state, action) => {
      state.isLoading = false;
      state.helpDeskComplaintData = action.payload;
    });
    builder.addCase(helpDeskComplaint.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default helpDeskComplaintSlice.reducer;
